import { apiClient } from "./apiClient";
import { endpoints } from "./endpoints";
import type { ApiRecord } from "@/types/api";

export const systemService = {
  async getStartup(): Promise<ApiRecord> {
    const response = await apiClient.get<ApiRecord>(endpoints.system.startup);
    return response.data;
  },
  async getReadiness(): Promise<ApiRecord> {
    const response = await apiClient.get<ApiRecord>(endpoints.system.readiness);
    return response.data;
  },
  async getLiveness(): Promise<ApiRecord> {
    const response = await apiClient.get<ApiRecord>(endpoints.system.liveness);
    return response.data;
  },
  async getVersion(): Promise<ApiRecord> {
    const response = await apiClient.get<ApiRecord>(endpoints.system.version);
    return response.data;
  },
  async getBuildInfo(): Promise<ApiRecord> {
    const response = await apiClient.get<ApiRecord>(endpoints.system.build);
    return response.data;
  },
};
